import Api from "@/api";
const route = "users";

const store = async body => {
  const result = await Api.post(`v1/${route}`, body);
  return result.data;
};

const index = async query => {
  const result = await Api.query(`v1/${route}`, query);
  return result.data;
};

const show = async userId => {
  const result = await Api.get(`v1/${route}`, userId);
  return result.data;
};

const update = async (body, id) => {
  const result = await Api.put(`v1/${route}`, id, body);
  return result.data;
};

const setStatus = async (body, id) => {
  const result = await Api.put(`v1/${route}/status`, id, body);
  return result.data;
};

const deleteUser = async id => {
  const result = await Api.delete(`v1/${route}`, id);
  return result.data;
};

const meRegister = async body => {
  const result = await Api.post(`v1/${route}/meRegister`, body);
  return result.data;
};

export default {
  store,
  index,
  show,
  update,
  setStatus,
  deleteUser,
  meRegister
};
